import { render, staticRenderFns } from "./KAlert.vue?vue&type=template&id=ed7626b6&"
import script from "./KAlert.vue?vue&type=script&lang=js&"
export * from "./KAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports